<template>
  <div v-if="isPrint" class="card-print">
    <h1 class="title-print" v-text="title"  />
    <ImagesTabs :images="images" :leadId="lead.id"/>
    <InfoTabs :options="options" :leadId="lead.id" />
  </div>
  <div v-else>
    <h1 class="title-main" v-text="title"  />
    <ImagesTabs :images="images" :leadId="lead.id"/>
    <CardInfo
      :description="description"
      :features="features"
      :price="price"
      :oldPrice="oldPrice"
      :leadId="lead.id"
    />
    <InfoTabs :options="options" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Common from '@/services/common'
import ImagesTabs from './ImagesTabs/ImagesTabs.vue'
import CardInfo from './CardInfo.vue'
import InfoTabs from './InfoTabs.vue'

export default {
  name: 'OneOffer',
  components: {
    ImagesTabs,
    CardInfo,
    InfoTabs,
  },
  props: {
    lead: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'config',
      'uploadsFields',
      'isPrint',
      'fieldsConfig',
    ]),
    cfs() {
      return this.lead.custom_fields_values || []
    },
    title() {
      const presentationName = this.prepareField(this.config.presentationNameFieldId).value
      const address = this.prepareField(this.config.address).value
      return presentationName || address || ''
    },
    price() {
      const { value: priceValue, measure } = this.prepareField(this.config.price)
      return priceValue && `${priceValue} ${measure}`
    },
    oldPrice() {
      const category = this.prepareField(this.uploadsFields.category).value
      const squareFieldId = category === 'Земельные участки'
        ? this.uploadsFields.landarea
        : this.uploadsFields.square

      return category && Common.divideTwoFields(this.cfs, this.config.price, squareFieldId, this.fieldsConfig)
    },
    description() {
      return this.prepareField(this.config.text).value
    },
    options() {
      return [this.config.address, ...this.config.options, this.config.price]
        .filter(Boolean)
        .map(this.prepareField)
        .filter(f => f.value)
    },
    features() {
      return this.config.options
        .map(this.prepareField)
        .filter(f => f.value)
        .slice(0, 3)
    },
    images() {
      const imagesValue = this.prepareField(this.config.images).value
      let images
      try {
        images = Object.keys(JSON.parse(imagesValue)) || []
        images = Common.imagesUrls(images, this.config.imagesHost, this.lead.id)
      } catch (e) {
        images = []
      }
      return images
    },
  },
  methods: {
    prepareField(fieldId) {
      return Common.prepareField({ cfs: this.cfs, fieldId, fieldsConfig: this.fieldsConfig })
    },
  },
}
</script>

<style scoped>
.title-print {
  font-size: 1em;
  line-height: 1em;
  font-weight: 700;
  text-align: center;
  height: auto;
  margin-bottom: 0 !important;
  padding: 1rem;
}
</style>
